import { useEffect, useState } from "react";
import { axiosPost } from "../../../utils/AxiosApi";
import { URL } from "../../../utils/Constants";

export const useEducationLevel = (allow = true) => {
  const [educationLevel, setEducationLevel] = useState([]);
  const [loading, setLoading] = useState(false);

  const getEducationLevel = () => {
    setLoading(true);
    axiosPost(
      URL.getARRModules,
      {},
      (response) => {
        if (response?.status === 200) {
          const result = response?.data.data;
          const processedData = result?.map((item) => ({
            label: item.name,
            value: item.code,
          }));
          setEducationLevel(processedData);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    if (!allow) return;
    getEducationLevel();
  }, []);

  return {
    educationLevel,
    setEducationLevel,
    loading,
    refethEducationLevel: getEducationLevel,
  };
};
